import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';


@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.css']
})
export class ProjectsComponent implements OnInit {


  data = [
    {
      name:"Agenda Técnica",
      descrip:"Aplicación para el manejo de equipos de trabajo técnicos",
      link:"https://www.google.com",
      image:"assets/porta/agenda.png"
    },
    {
      name:"Azocar Servicio",
      descrip:"Aplicación móvil y de escritorio para el manejo de servicio técnico",
      link:"https://www.google.com",
      image:"assets/porta/azocar.jpeg"
    },
    {
      name:"BuscoCasa CR",
      descrip:"Aplicación que conecta a arendatarios con clientes",
      link:"https://www.google.com",
      image:"assets/porta/busco.png"
    },
    {
      name:"Taller Digital",
      descrip:"Aplicación para el manejo de logistica de repración y entrega de equipos",
      link:"https://www.google.com",
      image:"assets/porta/taller.jpg"
    },
    {
      name:"Selector",
      descrip:"Aplicación para guiar a clientes en el proceso de selección, compra de calentador de agua y asistencia.",
      link:"https://selector.argoapps.com",
      image:"assets/porta/selector.png"
    },
    {
      name:"ICR APP",
      descrip:"Aplicación para el manejo cotizaciones, existencias de equipos, ordenes de pedidos y más...",
      link:"https://www.google.com",
      image:"assets/porta/icr.png"
    },
    {
      name:"E-commerce",
      descrip:"Aplicación web para compras online con control de inventario, guias, entregas, etc...",
      link:"https://www.google.com",
      image:"assets/porta/eco.jpeg"
    },
  ]

    // carousel option
    testimonialOptions: OwlOptions = {
 
 
 smartSpeed:200,
      loop: true,
      autoplay:true,
      responsive: {
        0: {
          items: 1
        },
        576: {
          items: 3
        },
      },
      nav: true,
    };

  constructor() { }

  ngOnInit(): void {
  }

}
